import { NgModule } from '@angular/core';
import { EqualValidator } from './equal.validator.directive';

@NgModule({
    declarations: [EqualValidator],
    exports: [EqualValidator]
})
export class ValidationModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/validation/validation.module.ts